import { FeedListItem } from "./FeedListItem";

export default FeedListItem;
